import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FilterProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}
const Filter: React.FC<FilterProps> = ({
  icon,
  label,
  value,
  options,
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={dropdownRef} data-id="element-11699">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center px-3 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-11700">
        <span className="text-gray-500 mr-2" data-id="element-11701">{icon}</span>
        <span className="mr-2" data-id="element-11702">{value}</span>
        <ChevronDownIcon size={16} className="text-gray-400" data-id="element-11703" />
      </button>
      {isOpen && <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10" data-id="element-11704">
          <div className="py-1" data-id="element-11705">
            {options.map(option => <button key={option} onClick={() => {
          onChange(option);
          setIsOpen(false);
        }} className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-11706">
                {option}
              </button>)}
          </div>
        </div>}
    </div>;
};
export default Filter;